<template>
  <div class="pa-4 tn-home">
    열쩡테니스
    <h1>{{recentMile.content}}</h1>
  </div>
</template>

<script>
import {getMileages} from "../api/mileage";

export default {
  name: "Home",
  data(){
    return {
      mileages: []
    }
  },
  computed: {
    recentMile(){
      return this.mileages[0] || {}
    }
  },
  mounted() {
    this.initMeta();
  },
  methods: {
    async initMeta(){
      return Promise.all([
        getMileages()
      ]).then(([mileages]) =>{
        this.mileages = mileages
      })
    }
  }
}
</script>

<style lang="scss">
.tn-home{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>